var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"col":"12"}},[_c('v-card',[_c('reporting-list',{attrs:{"loading":_vm.loading,"reportingList":_vm.reporting}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }